import { Loader2Icon } from "lucide-react";
import { cn } from "../lib/cn";

function Spinner({ className, ...props }: React.ComponentProps<"svg">) {
  const labelled = "aria-label" in props;
  return (
    <Loader2Icon
      slot="spinner"
      role={labelled ? "status" : undefined}
      aria-hidden={labelled ? undefined : true}
      className={cn("size-4 animate-spin", className)}
      {...props}
    />
  );
}

export { Spinner };
